import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import { styled, createTheme, ThemeProvider, lighten } from '@mui/material/styles';
import { drawerWidth } from './helper';

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  backgroundColor: lighten(theme.palette.primary.main, 0.97),
  color: theme.palette.primary.main,
  boxShadow: 'none',
  borderBottom: '1px solid #ddd',
  borderLeft: 'none',
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  '& .MuiIconButton-root': {
    color: theme.palette.primary.main,
  },
  '& .MuiTypography-root': {
    color: theme.palette.primary.main,
    fontSize: '1rem',
  },
  '& .MuiButton-root': {
    color: theme.palette.primary.main,
    fontSize: '0.875rem',
    '&:hover': {
      backgroundColor: `${theme.palette.primary.main}11`,
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1.25rem',
    },
  },
  '& .MuiSvgIcon-root': {
    color: theme.palette.primary.main,
  },
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default AppBar;
